import React from "react";
import Card from "react-bootstrap/Card";
import { ImCheckmark } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "center" }}>
            Hi Everyone, I am <span className="textColor">Simone Perego </span>
            from <span className="textColor"> Milan, Italy.</span>
            <br />I am a full stack developer with a degree in computer science.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImCheckmark /> Playing Video Games
            </li>
            <li className="about-activity">
              <ImCheckmark /> Travelling
            </li>
            <li className="about-activity">
              <ImCheckmark /> DJing
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
